import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/content';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 text-lg">
              <i className="ri-movie-2-line" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950">榴莲视频</span>
              <span className="text-[10px] tracking-widest text-foreground-500 mt-0.5">DURIAN VIDEO</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md transition-colors hover:text-primary-700 hover:bg-primary-50"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#hot"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-play-circle-line" />
              开始观看
            </a>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-700 rounded-md bg-background-100 transition-colors hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#hot"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-play-circle-line" />
            开始观看
          </a>
        </div>
      ) : null}
    </header>
  );
}